const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M140.267 68.703C145.298 76.828 148 86.204 148 96c0 13.89-5.41 26.948-15.23 36.77l-5.658-5.658C135.423 118.802 140 107.752 140 96c0-7.636-1.943-14.97-5.576-21.453l5.843-5.844zM174.83 22.83l-5.658-5.658-152 152 5.658 5.658 152-152zM50.686 124.343l5.657-5.657L49.657 112H24V80h25.657L84 45.657v45.372l8-8V26.343L46.343 72H16v48h30.343l4.343 4.343zM84 124.97v21.372l-10.686-10.686-5.657 5.657L92 165.657V116.97l-8 8zm70.676-70.677c19.993 28.1 17.416 67.437-7.764 92.618l5.657 5.657c28.308-28.309 30.921-72.727 7.847-104.014l-5.74 5.74z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volume-off.5a1326c12645c64c8a788992093fc56b.svg";
export { ForwardRef as ReactComponent };